<template>
	<!-- Displays a list of products and a sidebar -->
	<div class="row">
		<ListingHeader :title="listingName" :savings="categorySavings" />
		<div class="col-md-2 offset-md-1">
			<ListingSidebar 
				:listingName="listingName" 
				:allProducts="allProducts" 
				:products="products" 
				:brandsData="brandsInListingData" 
				@brandsFirstEvent="brandsFirst = $event"
				@sortingAlgoEvent="sortingAlgo = $event"
			/>
			<CategorySidebar class="col-md-12"/>
		</div>
		<div class="col-12 col-md-8">

			<!--<ListingBrands v-if="brandsInListingData" :brandsData="brandsInListingData" :listingName="listingName" class="row"/>-->

			<div class="row productListingOptions">
				<strong class="col-12 col-md-1">Show:</strong>
				<div class="col-12 col-md-3 showCount">
					<span
						v-for="option in showOptions"
						:key="option"
						@click="() => {itemsPerPage = option; pageNumber = 0;}"
						:class="{current: itemsPerPage == option}"
						class="displayOption"
					>
						<span class="displayOptionText">{{option == 10000 ? 'All' : option}}</span>
					</span>
				</div>
				<div class="col-12 offset-md-3 col-md-5">
					<SearchBar class="listingSearchBar" :searchFunc="debounceSearch" :placeholder="'Search ' + listingName" ref="searchBar"/>
				</div>
			</div>

			<Loading  :loading="loading" id="listing" class="row">
				<div v-if="products.length > 0" class="col-12">
					<transition-group name="fade" type="out-in" tag="div" class="row itemContainer" appear>
						<ListItem
							v-for="item in products"
							:key="item.id"
							:item="item"
							class="col-12 col-sm-6 col-md-4 col-lg-3"
						/>
					</transition-group>
					<PaginationButtons :pageNumber="pageNumber" :pageCount="pageCount"/>
				</div>
				<div v-else class="col-12 text-center my-4">
					<p>
						No related items are currently loaded on our website. Remember that we have <strong>over 550,000 products</strong> available so please use the ‘<router-link :to="{name: 'get-a-price'}">Request Price</router-link>’ button to submit your request and our quotes team will get back to you with a price and availability shortly
					</p>
					<p class="mt-4">
						Or try refining your filters to see more results.
					</p>
					<ClearFiltersButton class="btn btn-primary mx-auto mb-5" :extraFunc="() => {this.search = ''; this.$refs.searchBar.clear()}"/>
				</div>
			</Loading>
		</div>
		<!-- TODO what is this below -->
		<ListingBrands v-if="brandsInListingData" :brandsData="brandsInListingData" :listingName="listingName" class="col-12 row"/>
		<!--
		<ListingBrandsBottomtarget: 'https://www.cherrytree.co.nz/',
		:listingName="listingName"
		/>
		-->
		<vue-headful :title="'Shop ' + listingName + ' | Cherrytree'" :description="listingName"/>
	</div>
</template>

<script>
import { mapState } from "vuex";
import { fetchListing, fetchBrandsInListing} from "@/network/listingRequests";
import ListItem from "./ListItem";
import ListingSidebar from "./ListingSidebar";
import Loading from "@/components/loading/Loading";

import PaginationButtons from "@/components/paginationButtons";
import ClearFiltersButton from "@/components/buttons/ClearFiltersButton"

import ListingBrands from "./ListingBrands";
import ListingHeader from "./ListingHeader";
// import ListingBrandsBottom from "./ListingBrandsBottom";

import SearchBar from "@/components/searchBar";
// import ListingBrandsSidebar from "./ListingBrandsSidebar";

import { filterListing } from "./filterListing";
import { sortListing } from "./sortListing";
import { fetchCatSavings } from "@/network/categoryRequests";

import CategorySidebar from "@/sections/shop/category/CategorySidebar";

export default {
	name: "ProductListing",
	components: {
		ListItem,
		PaginationButtons,
		Loading,
		ListingSidebar,
		ListingBrands,
		// ListingBrandsBottom,
		ListingHeader,
		ClearFiltersButton,
		SearchBar,
		CategorySidebar,
	},
	data: () => {
		return {
			listingData: [], //will hold data about listing
			allProducts: [],
			loading: false,
			itemsPerPage: 48, //default
			sortingAlgo: "TitleAZ", //sort A-Z by default
			brandsFirst: false,
			searchTimeout: null, //store timeout for searching locally
			brandsInListingData: [],
			savings: null,
			hasRefineQuery: null,
			refineQuery: null,
			refineArray:null,
			hasBrandQuery:null,
			brandQuery:null,
			
			
		};
	},
	//called every time the before component is shown
	created() {
		this.getData();
		let urlParams = new URLSearchParams(window.location.search);
		
		this.hasRefineQuery = urlParams.has('refine');
		this.refineQuery = urlParams.get('refine');
		if (this.hasRefineQuery == true ){
			this.refineArray = this.refineQuery.split(",");
		}
		
		this.hasBrandQuery = urlParams.has('brand');
		this.brandQuery = urlParams.get('brand');
		
		
		//console.log("refine: " + urlParams.has('refine')); 	//true
		//console.log("brand: " + urlParams.get('brand')); 		//"MyParam"
	},
	methods: {
		getData() {
			this.loading = true;
			let query_data = {
				listingId: this.listingId // get listing id from url/router
			};
			fetchListing(
				query_data,
				listing => {
					this.allProducts = Object.values(listing);
					this.listingData.push(...Object.values(listing));
					this.loading = false;
				},
				error => {
					console.log(error);
				}
			);

			const brands_query_data = { listingId: this.listingId };
			fetchBrandsInListing(brands_query_data).then(brandsInListing => {
				this.brandsInListingData = brandsInListing;
				this.listingData.push(...brandsInListing);
			});

			fetchCatSavings(
				this.listingId,


				res => {
					this.savings = res;
				}
			)


		},

		//saves computation by only searching maximum once every 150ms
		debounceSearch(val){
			if(this.searchTimeout) clearTimeout(this.searchTimeout);
			this.searchTimeout = setTimeout(() => {
				this.updateSearch(val)
			}, 150);
		},

		//update search params in route
		updateSearch(val){
			let oldQuery = this.$route.query;
			let newQuery;

			if(val == '') val = undefined;

			//if query defined, save old query so we don't lose brand filters etc
			if(oldQuery){
				newQuery = {...oldQuery, search: val}
			}else{
				newQuery = {search: val}
			}
			//update query search param
			this.$router.replace({query: newQuery})
		}
	},
	watch: {
		//check if the items present have changed and if they have then reset pagination to 0
		filtered: function(oldItems, newItems) {
			if (oldItems.length == newItems.length) {
				for (let i = 0; i < oldItems.length; i++) {
				if (oldItems[i] != newItems[i]) {
					this.pageNumber = 0;
					return;
				}
				}
			} else {
				this.pageNumber = 0;
			}
		},
			// check if category/subcategory has changed and fetch new data if so
		"$route.params"(oldVal, newVal) {
			if (oldVal.toString() == newVal.toString()) {
				return;
			}
			this.getData();
		},
	},
	computed: {
		...mapState({
			// map categories to store.reference.categories
			categories: state => state.reference.categories
		}),
		listingId() {
			return this.$route.params.subcategory;
		},
		filtered() {
			//setup refine id
			let { priceHigh, priceLow, brand, refine, search } = this.$route.query;
			let price_key = "member_price";

			return filterListing(
				this.listingData,
				priceHigh,
				priceLow,
				brand,
				refine,
				search,
				null,
				price_key
			);
		},
		sorted() {
			let priceKey = this.$store.state.auth.memberLevel;
			return sortListing(
				this.filtered,
				this.sortingAlgo,
				this.brandsFirst,
				false,
				priceKey
			)
		},
		paginated() {
			const start = (this.pageNumber -1) * this.itemsPerPage;
			const end = start + this.itemsPerPage;
			return this.sorted.slice(start, end);
		},
		pageCount() {
			let l = this.filtered.length,
				s = this.itemsPerPage;
			return Math.ceil(l / s);
		},
		pageNumber: {
			get() {
				if (this.$route.query && this.$route.query.page) {
					return parseInt(this.$route.query.page);
				}
				return 1;
			},
			//when page number is set, update query param in route
			set(val) {
				// eslint-disable-next-line
				const { page, ...oldQuery } = this.$route.query;
				if (val === 0 || val === undefined || val === 1) {
					//remove page from query params if page number is 0 or 1
					// this.$router.push({ query: { ...oldQuery } });  //// THIS IS THE FUCKING LINE DUPLICATING NAVIGATION
				} else {
					this.$router.push({ query: { page: val, ...oldQuery } });
				}
			}
		},
		products() {
			return this.paginated;
		},
		brands() {
			let listingArray = Object.values(this.listingData);
			return listingArray.filter(listing => {
				return parseFloat(listing.retail_price) == 0;
			});
		},
		listingName() {
			const catId = this.$route.params.category;
			const subcatId = this.$route.params.subcategory;
			if (!catId || !subcatId || !this.categories) {
				return "";
			}
			return this.categories[catId].children[subcatId].category;
		},
		showOptions() {
			let options = [12, 24, 48, 100, 1000];
			return options;
		},
		categorySavings() {
			let savingsString = "";


			let min_saving = 999999999;
			let max_saving = 0;
			//console.log( this.allProducts );
			//console.log( this.products );
			for (let i = 0; i < this.allProducts.length; i++) {
                //console.log ( "saving: " + this.allProducts[i].prices.gold.saving_percent + " " + max_saving);
				
				//console.log(this.allProducts[i]);
				
				
				if ( this.hasBrandQuery == true ){
					if ( this.allProducts[i].brand_id_fk != this.brandQuery ){				
						continue;
					}
					
				}
				let inRefine = false;
				if ( this.hasRefineQuery == true ){				
					for ( let x = 0 ; x < this.allProducts[i].categories.length; x ++ ) {
						if ( this.refineArray.includes(this.allProducts[i].categories[x] )  ){
							//console.log(this.allProducts[i].categories[x]);
							inRefine = true;
							break;
						}
					}
					if (inRefine == false){
						continue;
					}
				}
				
				//console.log(this.allProducts[i].id + " " + this.allProducts[i].prices.gold.saving_percent );
				if (  this.allProducts[i].prices.gold.saving_percent > 0 ){
					if ( min_saving > this.allProducts[i].prices.gold.saving_percent ){				
						min_saving = this.allProducts[i].prices.gold.saving_percent;
					}
					
					if ( max_saving < this.allProducts[i].prices.gold.saving_percent){
						  max_saving = this.allProducts[i].prices.gold.saving_percent;
					}
				}
            }
            if ( this.allProducts.length > 0 ){
				savingsString = "Gold Members save between " + min_saving.toFixed(1) + " and " + max_saving.toFixed(1) + "%";
			}			
            /*
			if (this.savings != null && this.savings.max_saving != null && this.savings.min_saving != null) {
				savingsString = "Gold Members save between " + this.savings.min_saving + " and " + this.savings.max_saving + "%";
			}
			*/
			return savingsString
		}
	}
};
</script>

<style lang="scss" scoped>
	.fade-leave-active {
		transition: all 0.3s ease;
	}

	.fade-enter-active {
		transition: all 0.5s ease;
		transition-delay: 0.3s;
	}
	.fade-enter,
	.fade-leave-to {
		opacity: 0;
	}

	.itemContainer {
		overflow: hidden;
	}

	.productListingOptions{
		padding-top:10px;
		padding-bottom:10px;
		font-size:0.8em;
	}

	.showCount {
		//add dashes between sort options
		.displayOption {
			&:not(:last-of-type)::after {
				content: " - ";
			}

			&.current .displayOptionText {
				font-weight: bold;
			}
		}

		.displayOptionText{
			cursor:pointer;
			&:hover {
				text-decoration: underline;
			}
		}
	}
	@include media-breakpoint-down(sm){
		.productListingOptions{
			padding-top: 20px;
			padding-bottom: 20px;
		}

		.listingSearchBar{
			margin-top: 20px;
		}

		.listItem{
			padding: 20px 10px;
		}
	}

	.savings {
		font-size: 1.5rem;
	}
</style>
